import DuckEntity from './DuckEntity';

const entity = new DuckEntity('apiUsers');

export default entity.reducer;
export { entity };
